var poll_default = {
  "fontElementMap": "Xlbg9",
  "container": "_1AVPq",
  "fullscreen": "_--3BG",
  "background_overlay": "dbcqo",
  "with_image": "JyuK1",
  "options": "C9rAm",
  "webview": "sxIjV",
  "grid": "STKuu",
  "option": "zUA3R",
  "cta_button": "f9SlQ",
  "add_option": "_6lQAb",
  "see_more": "uJPE9",
  "list": "ONMC-",
  "column": "_7oKzr",
  "additional_note": "_5vHn4",
  "spinner": "_0dr4v",
  "spin": "KF7mL",
  "shown": "_8rPhh",
  "error": "S2YOr"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
